import { render, staticRenderFns } from "./SendTextEssay.vue?vue&type=template&id=679ff55e&scoped=true&"
import script from "./SendTextEssay.vue?vue&type=script&lang=js&"
export * from "./SendTextEssay.vue?vue&type=script&lang=js&"
import style0 from "./SendTextEssay.vue?vue&type=style&index=0&id=679ff55e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ff55e",
  null
  
)

export default component.exports